import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-component font-medium transition-smooth focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-[#6f5bff] !text-white hover:bg-[#6f5bff]/90 dark:bg-[#8b7aff] dark:!text-white dark:hover:bg-[#8b7aff]/90",
        secondary: "bg-sidebar text-foreground hover:bg-border",
        outline: "border border-border bg-background hover:bg-sidebar hover:text-foreground",
        destructive: "bg-[#e5484d] !text-white hover:bg-[#e5484d]/90 dark:bg-[#ff6b6b] dark:!text-white dark:hover:bg-[#ff6b6b]/90",
        ghost: "hover:bg-sidebar hover:text-foreground",
        link: "text-[#6f5bff] dark:text-[#8b7aff] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-component px-3 text-small",
        lg: "h-10 rounded-component px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
